var _path, _path2, _ellipse, _ellipse2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "point_svg",
    width: 122,
    height: 143,
    viewBox: "0 0 122 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.336 58.613C115.336 78.6733 103.245 95.435 89.2419 109.087C82.766 115.401 76.1204 120.824 70.3934 125.499C69.9829 125.834 69.5771 126.165 69.1764 126.492C66.227 128.902 63.4763 131.171 61.265 133.203C61.0968 133.357 60.928 133.514 60.7593 133.672C58.0801 131.248 54.9135 128.704 51.6929 126.115C51.4517 125.922 51.2103 125.728 50.9687 125.533C44.8099 120.581 37.8203 114.942 31.1736 108.364C17.8276 95.1568 6.66406 78.9431 6.66406 58.613C6.66406 29.7183 30.826 6 60.9999 6C91.1738 6 115.336 29.7183 115.336 58.613Z",
    stroke: "url(#paint0_linear_4685_71120)",
    strokeWidth: 12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.725 59.7627C108.725 75.7227 97.9526 90.82 85.0631 103.571C78.7468 109.819 72.2243 115.215 66.8094 119.612C66.2683 120.052 65.7347 120.484 65.2114 120.908C63.1553 122.574 61.2578 124.111 59.6917 125.443C59.6793 125.453 59.6669 125.464 59.6544 125.474C57.2841 123.268 54.5956 120.949 51.8391 118.571C51.3469 118.147 50.8525 117.72 50.3575 117.292C44.9954 112.657 39.1756 107.54 33.7304 101.761C22.7888 90.1509 14.006 76.5433 13.5594 60.1738C12.7977 32.248 33.6092 12.8961 60.9975 12.8961C88.1616 12.8961 108.725 34.0586 108.725 59.7627Z",
    stroke: "url(#paint1_linear_4685_71120)",
    strokeWidth: 12
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.0001,
    cy: 58.6135,
    rx: 16.6642,
    ry: 16.6645,
    fill: "url(#paint2_linear_4685_71120)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.9979,
    cy: 58.6161,
    rx: 8.04478,
    ry: 8.04492,
    fill: "url(#paint3_linear_4685_71120)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4685_71120",
    x1: 60.9999,
    y1: 21.8362,
    x2: 60.9999,
    y2: 152.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78B9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#417CF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4685_71120",
    x1: 61.0018,
    y1: 23.2733,
    x2: 61.0018,
    y2: 154.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#448EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67B2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4685_71120",
    x1: 61.0001,
    y1: 41.949,
    x2: 61.0001,
    y2: 75.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3975F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4685_71120",
    x1: 60.9979,
    y1: 50.5712,
    x2: 60.9979,
    y2: 66.6611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#448EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448EF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.1b4a5ef4.svg";
export { ForwardRef as ReactComponent };